module.exports = __webpack_public_path__ + "f9e5668e.svg";